import React from 'react'

import LazyImage from '@/components/LazyImage'
import { fallbackImg } from '@/constants/assets'


import { tw } from 'tagged-classnames-free';
export interface AvatarProps {
  url?: string | null
  className?: string
  name?: string | null
}

const Avatar: React.FC<AvatarProps> = (props) => {
  const { url, name, className } = props
  return (
    <div
      className={tw`
        bg-f-blue-5 hover:bg-f-blue-6 peer flex size-7 items-center justify-center
        rounded-full font-semibold text-white hover:cursor-pointer ${className}
      `}
    >
      {url ? (
        <LazyImage
          src={url}
          alt='user photo'
          width={28}
          height={28}
          fill={false}
          className='rounded-full'
        />
      ) : name && name.length > 0 ? (
        name.charAt(0).toUpperCase()
      ) : (
        <LazyImage
          src={fallbackImg}
          alt='fallback user photo'
          width={28}
          height={28}
          fill={false}
          className='rounded-full'
        />
      )}
    </div>
  )
}

export default Avatar
